/** 独立静态包跳转（/link/{vendor}/{channel}/{action}） */
export type DeviceLinkQueryMode = "auto" | "preset" | "none";

export interface DeviceLinkConfig {
  /** 方案商目录名，如 ry、xsyd、jm */
  vendor: string;
  /** 载体，默认 web */
  channel: string;
  /** 连接动作，默认 connect */
  action: string;
  /**
   * auto：点击时追加 productId、vendorId、productName（十进制 ID，与旧 Hub 一致）；
   *       若同时配置 presetQuery（如 jm 的 cid/mid），会先写入 preset 再追加 auto 参数
   * preset：仅使用 presetQuery
   * none：不追加 auto 参数（仍可使用 presetQuery）
   */
  queryMode?: DeviceLinkQueryMode;
  presetQuery?: Record<string, string | number | boolean>;
}

/** 独立包读此参数展示「返回 Hub」；由 buildDeviceLinkUrl 写入 */
export const HUB_RETURN_URL_QUERY = "hubReturnUrl";
